import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    padding: theme.spacing(5),
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    '& p': {
      fontSize: '16px',
      marginTop: '10px',
      color: theme.palette.secondary.gray,
    },
    '& span': {
      borderBottom: `1px solid ${theme.palette.secondary.blue}`,
    },
    '& button': {
      color: theme.palette.custom.solidButtonText,
      float: 'right',
    },
  },
  title: {
    flexGrow: 1,
    fontSize: '24px',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: theme.palette.primary.mainBlue,
  },
}));

export default useStyles;
